import { render, staticRenderFns } from "./EditTagModal.vue?vue&type=template&id=39e6b48e&scoped=true"
import script from "./EditTagModal.vue?vue&type=script&lang=js"
export * from "./EditTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e6b48e",
  null
  
)

export default component.exports